import { alpha } from '@mui/material/styles';

import type { SxProps, Theme } from '@mui/material/styles';

export const INVENTORY_THUMB_PX = 56;

export const inventoryItemTitleSx: SxProps<Theme> = {
    fontSize: '1.4rem',
    fontWeight: 600,
    lineHeight: '2rem',
    color: '#000000',
};

export const inventoryDataCellSx: SxProps<Theme> = {
    verticalAlign: 'middle',
};

export const inventoryCellTextSx: SxProps<Theme> = (theme) => ({
    fontWeight: 400,
    fontSize: '1.4rem',
    lineHeight: 'normal',
    color: alpha(theme.palette.common.black, 0.85),
});

export const inventoryUomCellTypographySx = inventoryCellTextSx;

export const inventoryMinOnHandTypographySx: SxProps<Theme> = (theme) => ({
    fontWeight: 400,
    fontSize: '1.4rem',
    lineHeight: '2rem',
    color: alpha(theme.palette.common.black, 0.85),
});

export const inventoryPriceTypographySx: SxProps<Theme> = (theme) => ({
    fontWeight: 400,
    fontSize: '1.4rem',
    lineHeight: '2rem',
    color: alpha(theme.palette.common.black, 0.85),
});

export const inventoryCategoryTextSx: SxProps<Theme> = {
    fontWeight: 400,
    fontSize: '1.4rem',
    lineHeight: 'normal',
    color: 'rgba(0, 0, 0, 0.85)',
};

export const columnWidths: Record<string, string> = {
    item: '45%',
    thumbnail: '56px',
    category: '180px',
    uom: '120px',
    minOnHand: '88px',
    buttons: '48px',
    orderAdd: '110px',
};
